<ion-header [translucent]="true">
    <ion-toolbar>
        <ion-title></ion-title>
    </ion-toolbar>
</ion-header>

<ion-content [fullscreen]="true">
    <ion-header collapse="condense">
        <ion-toolbar>
            <ion-title size="large"></ion-title>
        </ion-toolbar>
    </ion-header>

    <ion-grid [fixed]="true">



        <ion-row>

            <ion-col size="12" class="flex-center">

                <ng-container [ngSwitch]="State">

                    <ng-container *ngSwitchCase="EnumPageStates.NOTFOUND">

                        <ion-card>

                            <ion-card-title class="flex-align-center flex-center">404</ion-card-title>
                            <ion-card-content>
                                <ion-grid>
                                    <ion-row>
                                        <ion-col class="flex-align-center flex-center">
                                            <ion-text>Página não foi encontrada</ion-text>
                                        </ion-col>
                                    </ion-row>
                                    <ion-row>
                                        <ion-col class="ion-margin-top flex-align-center flex-center">
                                            <ion-button color="primary" (click)="GoBack()">Voltar</ion-button>
                                        </ion-col>
                                    </ion-row>
                                </ion-grid>
                            </ion-card-content>
                        </ion-card>

                    </ng-container>

                    <ng-container *ngSwitchCase="EnumPageStates.SESSIONENDED">

                        <ion-card>

                            <ion-card-title class="flex-align-center flex-center">419</ion-card-title>
                            <ion-card-content>
                                <ion-grid>
                                    <ion-row>
                                        <ion-col class="flex-align-center flex-center">
                                            <ion-text>A sua sessão expirou</ion-text>
                                        </ion-col>
                                    </ion-row>
                                    <ion-row>
                                        <ion-col class="ion-margin-top flex-align-center flex-center">
                                            <ion-button color="primary" (click)="GoBack()">Voltar</ion-button>
                                        </ion-col>
                                    </ion-row>
                                </ion-grid>
                            </ion-card-content>
                        </ion-card>

                    </ng-container>


                    <ng-container *ngSwitchDefault>
                        <ion-card>

                            <ion-card-title class="flex-align-center flex-center">State</ion-card-title>
                            <ion-card-content>
                                <ion-grid>
                                    <ion-row>
                                        <ion-col class="flex-align-center flex-center">
                                            <ion-text>Ocorreu ao carregar a página</ion-text>
                                        </ion-col>
                                    </ion-row>
                                    <ion-row>
                                        <ion-col class="ion-margin-top flex-align-center flex-center">
                                            <ion-button color="primary" (click)="GoBack()">Recarregar</ion-button>
                                        </ion-col>
                                    </ion-row>
                                </ion-grid>
                            </ion-card-content>
                        </ion-card>
                    </ng-container>
                </ng-container>

            </ion-col>

        </ion-row>
    </ion-grid>
</ion-content>